// removed by extract-text-webpack-plugin
module.exports = {"selectedBuildings":"SelectionSummary-hashed__selectedBuildings__1Rw7-","summaryList":"SelectionSummary-hashed__summaryList__3ctib","row":"SelectionSummary-hashed__row__11l7m","deleteIcon":"SelectionSummary-hashed__deleteIcon__e7gaa","summaryHeader":"SelectionSummary-hashed__summaryHeader__1nr96","summaryContainer":"SelectionSummary-hashed__summaryContainer__25dXE","summaryFooter":"SelectionSummary-hashed__summaryFooter__2jgnZ"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/cp/components/SelectionSummary/SelectionSummary-hashed.scss
// module id = 1166
// module chunks = 0